
seedWebServices.service('EmailService', ['$http', '$cacheFactory', '$uibModal', 'TranslationService', 'ToastService', '$window', '$timeout',
    function ($http, $cacheFactory, $uibModal, TranslationService, ToastService, $window, $timeout) {

        var ctrl = this;
        var serviceCache = $cacheFactory('EmailService');
        var URL = '../Api/Email/';

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.getEmails = function (filterString, options, skipNumber, takeNumber, sort) {
            return $http.put(URL + 'Emails',
                { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
                { cache: serviceCache }
            );
        };

        this.getEmail = function (emailID) {
            return $http.get(URL + 'Email', {
                params: { emailID: emailID }
            });
        };

        this.saveEmail = function (email) {
            return $http.post(URL + 'Email', { email: email });
        };

        this.updateEmail = function (email) {
            return $http.put(URL + 'Email', { email: email });
        };

        this.deleteEmail = function (emailID) {
            return $http.delete(URL + 'Email', {
                params: { emailID: emailID }
            });
        };

        this.getDocTypeList = function () {
            return $http.get(URL + 'DocTypes', { cache: serviceCache });
        };


        this.getDocTypeFromEmail = function (emailID) {
            return $http.get(URL + 'EmailDoc', {
                params: { emailID: emailID }
            });
        };

        this.sendTestEmail = function (email) {
            return $http.put(URL + 'SendTestEmail', email);
        };
    }
]);